export default (node) => {
  const allTitles = node.querySelectorAll('[data-cc-title]');

  const renderTitles = () => {
    const titlesContainer = node.querySelector('[data-cc-titles]');
    allTitles.forEach((title, index) => {
      const liElement = document.createElement('li');
      liElement.classList.add(
        'bg-transparent',
        'cursor-pointer',
        'w-max',
        'hover:border-b',
        'hover:border-black',
        'hover:border-solid'
      );
      liElement.innerText = title.getAttribute('data-cc-title');
      liElement.setAttribute(
        'data-cc-title-slug',
        title.getAttribute('data-cc-group')
      );
      titlesContainer.appendChild(liElement);
    });
  };

  const addTitlesListener = () => {
    const allMainTitles = node.querySelectorAll('[data-cc-titles] > li');

    allMainTitles.forEach((title) => {
      title.addEventListener('click', (e) => {
        const slug = e.currentTarget.getAttribute('data-cc-title-slug');

        const targetGroup = node.querySelector(`[data-cc-group="${slug}"]`);
        if (targetGroup) {
          window.scrollTo({
            top: targetGroup.offsetTop - 165,
            behavior: 'smooth',
          });
        }
      });
    });
  };

  const init = () => {
    renderTitles();
    addTitlesListener();
  };
  init();
};
